<template>
    <div>
    <Navbar v-if="this.$route.meta.navbar && mainfield == ''"/>
    <Breadcrumb v-if="this.$route.meta.navbar && mainfield == ''" />
        <b-alert 
            :show="written!='' && current_id != 0"
            variant="success"
            dismissable
        >
            <span v-show="written=='updated'">Record updated</span>
            <span v-show="written=='created'">Record created</span>
        </b-alert>
        <b-alert 
            :show="saveerror !== ''"
            variant="danger"
            dismissable
        >
            An error occurred while saving: {{ saveerror }}
        </b-alert>
        <!-- List -->
        <div v-if="current_id==0">
            <div class="justify-content-between pb-2 px-4">
                <span v-if="!nosearch" class="float-right">
                    <b-input-group small class="my-0">
                        <b-form-input
                            v-model="search"
                            placeholder="Search..."
                            type="text"
                            @input="data_search"
                            
                            autocomplete="off"
                        >
                        </b-form-input>
                        <b-input-group-text slot="append">
                            <b-btn
                                variant="link"
                                size="§"
                                @click="search = ''"
                                class="p-0 i"
                            >
                            X
                            </b-btn>
                        </b-input-group-text>
                    </b-input-group>
                </span>
                <span class="float-right mr-2">
                    <b-button v-if="!noexport" variant="secondary" @click.prevent="excelexport">
                        <fa-icon
                            name="file-excel"                        
                        />
                        Export
                    </b-button>
                </span> 
                <span v-if="!noedit" class="float-right mr-2">    
                    <b-button 
                        v-if="tablename!='g_questionnairetexts' && tablename!='g_reporttexts' && tablename!='g_shortreporttexts' && tablename != 'g_oscreporttexts' "
                        class="mr-2"
                        variant="primary"
                        @click.prevent="record_new">
                        <fa-icon
                            name="plus"                        
                        />
                        Add new
                    </b-button>
                </span>          
            </div>
            <b-table
                responsive
                hover
                :items="records"
                :busy="loading || searching"
                :fields="tablefields"
                @row-clicked="record_edit"
                :sort-by="orderby"
                :sort-desc="orderdesc"
                @sort-changed="data_sort"
                :no-local-sorting="true"
            >
            <template #table-busy>
                <div class="text-center text-success my-2">
                <b-spinner class="align-middle mr-2" />
                <strong>Loading...</strong>
                </div>
            </template>
            <template v-for="(field, index) in tablefields" v-slot:[`head(${field.key})`]="data">
                <div v-bind:key="index" v-if="field.key=='id'">
                    <b-form-checkbox
                        @click.native.stop
                        @change="selectall(selected)"
                        v-model="selected"
                        value="1"
                        unchecked-value="0"
                    >
                    </b-form-checkbox>
                </div>
                <div 
                    v-bind:key="index+'caption'" 
                    v-if="field.key!='id'&&field.key!='actions'">
                    {{ field.label }}
                </div>
                <div v-bind:key="index+'filter'">
                    <span v-if="field.list_filter==1">
                        <b-form-input 
                            v-if="field.input_type=='TEXT'"
                            v-model="listfilter[field.field_name]"
                        />
                        <b-form-select
                            v-if="field.input_type=='SELECT'"
                            v-model="listfilter[field.field_name]"
                            :options="field.lookup_options" 
                            @change="data_filterget"           
                        >
                    </b-form-select>                       
                    </span>
                    <div 
                        v-if="field.list_filter!=1" 
                        class="gdq-input-placeholder"
                        style="height: 39px"
                    ><font color="white">.<br></font></div>
                </div>
                </template>
                <template v-slot:cell(id)="data">
                    <div class="py-1">
                        <b-form-checkbox
                            v-model="data.item.selected"
                            @change="countselected"
                            value="1"
                            unchecked-value="0"
                        >
                            {{ data.item.id }}
                        </b-form-checkbox>
                    </div>
                </template> 
                <template v-slot:cell(actions)="data">
                    <fa-icon
                        v-if="!noedit"
                        @click.prevent.stop="record_delete_confirm(data.item.id)"
                        name="trash-alt"
                    />
                </template>
         
            </b-table>
            <b-row class="col-12 justify-content-center">
                <b-pagination
                    v-if="rows > perPage"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="records"
                    @input="data_get"
                >
                </b-pagination>
            </b-row>
        </div>
        <!-- Edit or create -->
        <div v-if="current_id != 0">
            <b-form-group class="pl-3">
                <b-button v-if="!standalone" variant="outline-primary" @click.prevent="current_id=0" class="mr-4">&lt; Return to list</b-button>
                <b-button class="float-right" variant="primary" @click.prevent="record_save">
                    <fa-icon
                        name="check"
                    />
                    Save
                </b-button>
                <b-button v-if="!standalone" class="float-right mr-4" variant="secondary" @click.prevent="record_savereturn">
                    <fa-icon
                        name="check"
                    />
                    Save and return to list
                </b-button>
                
            </b-form-group>
            <div
                v-for="dbfield in screenfields"
                v-bind:key="dbfield.id"
                :class="'col-'+dbfield.colspan+' float-left'"
            >
                <b-form-group>
                <template slot="label">
                    {{(dbfield.input_type!='CHECKBOX'&&dbfield.input_type!='GRID'&&dbfield.input_type!='NONE')?dbfield.input_caption:''}}
                    <span
                        v-if="dbfield.field_name=='consultant_id'"
                        class="mr-2"
                        @click.prevent.stop="switchto(record[dbfield.field_name])"
                        style="cursor: zoom-in"
                    >
                        <fa-icon name="key" />
                    </span>
                </template>
                    <datetime 
                        v-if="dbfield.input_type=='DATE'"
                        type="date"
                        format="yyyy-LL-dd"
                        v-model="record[dbfield.field_name]"
                        :disabled="dbfield.input_readonly=='1'"
                        :phrases="{ok: 'OK', cancel: 'Cancel'}"
                        value-zone="Europe/Stockholm"
                        zone="Europe/Stockholm"
                    ></datetime>
                    <b-form-input v-if="dbfield.input_type=='TEXT'" v-model="record[dbfield.field_name]" :disabled="dbfield.input_readonly=='1'" />
                    <password-input v-if="dbfield.input_type=='PASSWORD'" type="password" v-model="record[dbfield.field_name]" :disabled="dbfield.input_readonly=='1'" />
                    <b-form-input v-if="dbfield.input_type=='HIDDEN'" v-model="record[dbfield.field_name]" />
                    <b-form-textarea v-if="dbfield.input_type=='TEXTAREA'" rows=3  v-model="record[dbfield.field_name]" :disabled="dbfield.input_readonly=='1'"></b-form-textarea>
                    <vue-editor
                        v-if="dbfield.input_type=='HTML'" 
                        v-model="record[dbfield.field_name]"
                        :editor-toolbar="editortoolbar"
                    />
                    <b-form-checkbox 
                        v-if="dbfield.input_type=='CHECKBOX'" 
                        v-model="record[dbfield.field_name]"
                        value="1"
                        unchecked-value="0"
                    >
                        {{dbfield.input_caption}}
                    </b-form-checkbox>
                    <b-form-group>
                        <b-form-select
                            v-if="dbfield.input_type=='SELECT'" 
                            v-model="record[dbfield.field_name]"
                            :options="dbfield.lookup_options"
                            :disabled="dbfield.field_name==mainfield || dbfield.input_readonly == '1'"
                            @change="load_subselect(dbfield)"                  
                        >
                    
                        </b-form-select>
                        <b-form-select
                            v-if="dbfield.input_type=='SUBSELECT'" 
                            v-model="record[dbfield.field_name]"
                            :options="dbfield.lookup_options"
                            :disabled="dbfield.field_name==mainfield"                   
                        >
                        </b-form-select>
                    </b-form-group>                   
                    <b-form-radio-group
                        v-if="dbfield.input_type=='RADIO'" 
                        v-model="record[dbfield.field_name]"
                        :options="dbfield.lookup_options"
                        stacked  
                    >
                    </b-form-radio-group>
                    <b-card
                        :title="dbfield.input_caption"
                        v-if="dbfield.input_type=='GRID' && current_id > 0" 
                    >
                        <Maintenance
                            :tablename="dbfield.field_name"
                            :mainfield="dbfield.lookup_field"
                            :mainvalue="current_id"
                        />
                    </b-card>
                </b-form-group>
            </div>
             <b-button class="float-right" variant="primary" @click.prevent="record_save">
                <fa-icon
                    name="check"
                />
                Save
            </b-button>                    
        </div>
        <b-row>
            <b-alert 
                :show="written!='' && current_id != 0"
                variant="success"
                dismissable
            >
                <span v-show="written=='updated'">Record updated</span>
                <span v-show="written=='created'">Record created</span>
            </b-alert>
            <b-alert 
                :show="saveerror !== ''"
                variant="danger"
                dismissable
            >
                An error occurred while saving: {{ saveerror }}
            </b-alert>
        </b-row>
        <b-modal
            hide-footer
            title="Delete record?"
            v-model="deleteshow"
        >
            Do you really want to delete this record?
            <b-button class="mt-3" variant="danger" block @click="record_delete">Yes, delete</b-button>
            <b-button class="mt-2" variant="secondary" block @click="record_delete_cancel">Cancel</b-button>
        </b-modal>
    </div>
</template>
<script>
import _ from 'lodash';
import axios from 'axios'
import { VueEditor } from 'vue2-editor'
import { Datetime } from 'vue-datetime';
import { config } from '../../config';
import PasswordInput from './CustomControls/PasswordInput.vue';
import Navbar from './Navbar.vue';
import Breadcrumb from './Breadcrumb.vue';
const base_url = config.base_url;
const api_token = config.api_token;

const editortools = [
  [{ header: [false, 1, 2, 3, 4, 5, 6] }],
  ['bold', 'italic', 'strike'],
  [
    { align: '' },
    { align: 'center' },
    { align: 'right' },
    { align: 'justify' }
  ],
  [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
  [{ color: [] }, { background: [] }],
  ['link'],
  //  ["link", "image", "video", "formula"],
  ['image'],
]
const stripTags = (original) => {
            return original.replace(/(<([^>]+)>)/gi, "");
        };


export default {
    name: 'Maintenance',
    props: [
        'tablename',
        'mainfield',
        'mainvalue',
        'standalone',
        'noedit',
        'noexport',
        'nosearch',
        'fixedfilter',
    ],
    components: {
        Datetime,
        VueEditor,
        PasswordInput,
        Navbar,
        Breadcrumb,
    },
    data: function() {
        return {
            editortoolbar: editortools,
            loading: true,
            written: '',
            saveerror: '',
            dbfields:[],
            screenfields: [],
            tablefields: [],
            records: [],
            record: [],
            filter: {},
            listfilter: [],
            filtersep: 'AND',    
            currentPage: 1,
            perPage: 10,
            rows: 0,
            orderby: 'id',
            orderdesc: false,
            current_id: this.standalone | 0,
            search: '',
            searching: false,
            searchcalc: false,
            filtering: false,
            selectcount: 0,
            selected: 0,
            deleting: 0,
            deleteshow: false,
            lookupoptions: [],
            savereturn: false,
        }
    },
    watch: {
        search: function() {
            this.filtering = false
            this.searching = true
            this.data_search()
        },
        '$route.path': function() {
            this.init();
        },
    },
    created() {
        this.init();
    },
    mounted() {
        this.init();
    },
    methods: {
        excelexport() {
            const action = "records_exportexcel";
            this.$store
            .dispatch(action, { table_name: this.tablename, filter: JSON.stringify(this.filter) })
            .then((resp) => {
                var fileURL = window.URL.createObjectURL(new Blob([resp.data]));
                var fileLink = document.createElement("a");
                fileLink.href = fileURL;
                var filename = 'Export';
                fileLink.setAttribute("download", filename + ".xlsx");
                document.body.appendChild(fileLink);
                fileLink.click();
                this.loading=false;
                this.bulkaction = 0;
            });
        },
        async init() {
            await this.$nextTick();
            if ((this.mainfield)) {
                this.perPage = 5;
            }
            this.fields_get()
            .then(() => {
                this.data_filterget();
                if (this.current_id != 0) { this.record_edit( { id: this.current_id }); return true }  
            })
        },
        switchto(id) {
            this.$store
            .dispatch("switchto", { i_name: "", i_password: "", user_id: id })
            .then((resp) => {
                window.open(config.web_url + "/?t=" + resp, "GDQSwitchTo");
            });
        },
        record_new() {
            this.written = '';
            this.current_id=-1;
            for (var i=0;i<this.dbfields.length;i++) {
                const f = this.dbfields[i];
                this.record[f.field_name] = f.input_default;
                this.record[this.dbfields[i].lookup_options] = [];
                // Set defaul to user_id field if no input
                if (f.input_type == 'NONE') {
                    if (f.field_name=='user_id') {
                        this.record[f.field_name] = this.$store.state.user_id;
                    }
                }
            }
            if (this.mainfield) {
                this.record[this.mainfield] = this.mainvalue;
            }
        },
        record_savereturn() {
            this.savereturn = true;
            this.record_save()
        },
        record_save() {
            this.saveerror = '';
            var saverec = {
                id: this.current_id,
            }
            for (var i=0;i<this.dbfields.length;i++) {
                if (this.dbfields[i].input_type == 'DATE') {
                    saverec[this.dbfields[i].field_name] = this.format_date(this.record[this.dbfields[i].field_name]);
                } else {
                    saverec[this.dbfields[i].field_name] = this.record[this.dbfields[i].field_name];
                }
                if (this.dbfields[i].input_type == 'CHECKBOX') {
                    if (this.record[this.dbfields[i].field_name] == '' ) {
                        saverec[this.dbfields[i].field_name] = '0';
                    }
                }
            }
            if (this.current_id > 0) {
                this.record_put(saverec)
                .then((result) => {
                    if (result.data.error) {
                        this.saveerror = result.data.error;
                    } else {
                        if (!this.savereturn) {
                            this.written='updated';
                        }
                        this.data_get()
                        .then(() => {
                            if (this.savereturn) {
                                this.current_id = 0;
                            }
                        })
                    }
                })
            } else {
                this.record_post(saverec)
                .then((result) => {
                    if (result.data.error) {
                        this.saveerror = result.data.error;
                    } else {
                        this.current_id = result.data.id;
                        if (!this.savereturn) {                    
                            this.written='created';
                        }
                        this.data_get()
                        .then(() => {
                            if (!this.savereturn) { 
                                this.written = '';
                            }
                            if (this.savereturn) {
                                this.current_id = 0;
                            }                        
                        })
                    }
                })
            }
        },
        record_put(record) {
            axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
            return new Promise((resolve) => {
                axios.put(
                    base_url+"/"+this.tablename+"/"+this.current_id,
                    JSON.stringify(record), {
                        headers: {
                            "Accept": "application/json",
                            "Content-type": "application/json",
                        }
                    }
                )
                .then((resp) => {
                    resolve(resp);
                })                
            });
        },
        record_post(record) {
            axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
            return new Promise((resolve) => {
                axios.post(
                    base_url+"/"+this.tablename,
                    JSON.stringify(record), {
                        headers: {
                            "Accept": "application/json",
                            "Content-type": "application/json",
                        }
                    }
                )
                .then((resp) => {
                    resolve(resp);
                })
            });
        },
        record_edit(item) {
            if (this.$props.noedit != 'true') {
                this.written = '';
                for (var i=0;i<this.dbfields.length;i++) {
                    this.record[this.dbfields[i].field_name] = this.dbfields[i].input_default;
                    this.record[this.dbfields[i].lookup_options] = [];
                    this.load_subselect(this.dbfields[i]);
                }
                if (this.current_id != -1) {
                    axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
                    return new Promise((resolve) => {
                        axios.get(
                            base_url+"/"+this.tablename+"/"+item.id,
                            '', {
                                headers: {
                                    "Accept": "application/json",
                                    "Content-type": "application/json",
                                }
                            }
                        )
                        .then((resp) => {
                            const fields = this.dbfields;
                            fields.forEach((f) => { 
                                this.record[f.field_name] = resp.data[f.field_name];
                                this.load_subselect(f);
                            });
                            if (this.mainfield) {
                                this.record[this.mainfield] = this.mainvalue;
                            }                    
                            this.current_id = resp.data.id; 
                            resolve(resp);
                        })
                    })
                }
            }
        },
        record_delete_confirm(id) {
            this.deleting = id;
            this.deleteshow = true;
        },
        record_delete() {
            axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
            return new Promise(() => {
                axios.delete(
                    base_url+"/"+this.tablename+"/"+this.deleting,
                    '', {
                        headers: {
                            "Accept": "application/json",
                            "Content-type": "application/json",
                        }
                    }
                )
                .then(() => {            
                    this.deleting = 0;
                    this.deleteshow = false;
                    this.data_get();
                })
            });
        },
        record_delete_cancel() {
            this.deleting = 0;
            this.deleteshow = false;
        },
        fields_get() {
            axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
            return new Promise((resolve) => {
                axios.get(
                    base_url+"/fields/"+this.tablename,
                    '', {
                        headers: {
                            "Accept": "application/json",
                            "Content-type": "application/json",
                        }
                    }
                )
                .then(resp => {
                    // dbfields = all fields for the table from the DB
                    var dbfields = resp.data;

                    // Get fields for table display
                    const f = dbfields.filter(a => a.list_display == 1)
                    .map((a) => {
                        let tablefield = {
                            key: a.field_name,
                            sortable: true, 
                            label: a.list_caption,
                            tdClass: 
                                (a.input_type === 'TEXTAREA' || a.input_type === 'HTML') ?
                                'gdq-chop':
                                a.list_pixels != 0 ?
                                    'gdq-w'+a.list_pixels :
                                    a.list_filter == 1 ?
                                        'gdq-w170':
                                        '',
                            thClass: 'align-top ' + (a.list_pixels != 0 ? 'gdq-w'+a.list_pixels : a.list_filter == 1 ? 'gdq-w170':''), 
                            list_filter: a.list_filter,
                            field_name: a.field_name,
                            input_type: a.input_type,
                            lookup_options: a.lookup_options,
                            input_readonly: a.input_readonly,
                            formatter: a.input_type !== 'HTML' ?
                                value => {
                                    return value
                                }:
                                value => {
                                    return value ? stripTags(value):''
                                },
                        }
                        return tablefield;
                    });
                    // Add ID field first in table fields
                    console.log(this.tablename)
                    var r = [
                        {
                            key: 'id',
                            label: 'ID',
                            sortable: true,
                            list_filter: 0,
                            isHtml: 0,
                            thClass: this.tablename.indexOf('elearning') > 0 ? 'd-none': 'gdq-w-20px pt-2',
                            tdClass: this.tablename.indexOf('elearning') > 0 ? 'd-none': 'gdq-w-20px pt-2',
                        _}
                    ];
                    r.push.apply(r,f)
                    r.push({
                        key: 'actions',
                        label: '',
                        list_filter: 0,
                        isHtml: 0,
                    });
                    this.tablefields = r;
                    // Get ORDER BY field
                    const s = dbfields.filter(
                        a => a.key_field != 0 && a.field_type !== 'TABLE')
                        .map((a) => {
                            return {
                                orderby: a.field_name,
                                orderdesc: a.key_field == 2 ? true : false,
                            }
                        });
                    if (s.length > 0) {
                        this.orderby = s[0].orderby;
                        this.orderdesc = s[0].orderdesc;
                    }
                    console.log({s});
                    // Now, we need to find all fields that point to another field hmmm
                    const g = dbfields.filter(
                        a => a.input_type == 'SUBSELECT'
                    );
                    g.forEach( f => {
                        for (var i=0;i<dbfields.length;i++) {
                            if (dbfields[i].field_name == f.control_field) {
                                dbfields[i]['subtable'] = f.lookup_table;
                                dbfields[i]['subfield'] = f.subtable_filter_field;
                            }
                        }
                        
                    });
                    dbfields = dbfields.map( f => {
                        return {
                            ...f,
                            colspan: 12,
                        }
                    });
                    var start = -1;
                    const screenfields = dbfields.filter( f => f.input_type != 'NONE');
                    for (var i=0;i<screenfields.length;i++) {
                        if (screenfields[i].input_merge_next == 1 && start == -1) {
                            start = i;
                        }
                        if (screenfields[i].input_merge_next == 0 && start != -1 && i != start) {
                            const colspan = Math.round(12/((i+1)-start));
                            for (var j=start;j<=i;j++) {
                                screenfields[j].colspan = colspan;
                            }
                            start = -1;
                        }
                    }
                    this.dbfields = dbfields;
                    this.screenfields = screenfields;
                    for (var k=0; k<dbfields.length; k++) {
                        if (dbfields[k].list_filter == 1) {
                            this.listfilter[dbfields[k].field_name] = this.dbfields[k].input_default;
                        }
                    }      
                })
                .then(resp => {
                    resolve(resp);
                })
            });
        },
        load_subselects() {
            for (var i=0;i<this.dbfields.length;i++) {
                this.load_subselect(this.dbfields[i]);
            }
        },
        load_subselect(field) {
            if (field.subfield) {
                const table_name = field.subtable;
                const filter = {
                    [field.subfield]: {
                        operator: '=',
                        value: this.record[field.field_name],                 
                    }
                };
                 const lu = this.dbfields.filter (a => {
                    return a.lookup_table == table_name;
                });
                const lookup_field = lu[0].lookup_field;
                const lookup_display = lu[0].lookup_display;
                const lookup_sort = lu[0].lookup_sort;
                axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
                return new Promise((resolve,reject) => {
                    axios.get(
                        base_url+'/'+table_name+'?'
                        +'filter='+JSON.stringify(filter)
                        +'&orderby='+lookup_sort
                    )
                    .then(resp => {
                        const records = resp.data.result;
                        const v = records.map ((a) => {
                            return {
                                value: a[lookup_field],
                                text: a[lookup_field]+' - '+a[lookup_display],
                            }
                        });
                        for (var i=0;i<this.dbfields.length;i++) {
                            if (this.dbfields[i].control_field == field.field_name) {
                                this.dbfields[i].lookup_options = v;
                            }
                        }
                        resolve(resp);
                    })
                    .catch(err => {
                        reject(err)
                    })
                })                
            }
        },
        countselected() {
            this.$nextTick(() => {
                var selectcount = 0;
                for (var i=0;i<this.records.length; i++) {
                    if (this.records[i].selected) {
                        selectcount++;
                    }
                }
                this.selectcount = selectcount;
            })
        },
        selectall(selected) {
            const setselectto = selected==1?0:1;
            for (var i=0;i<this.records.length; i++) {
                this.records[i].selected = setselectto;
            }
            this.countselected();
        },     
        data_filterget() {
            if (!this.filtering) {
                const orderby = this.orderby;
                const orderdesc = this.orderdesc;
                this.filtering = true;
                this.searching = false;
                var filter = {};
                const filterfields = this.tablefields.filter((f) => {
                    return f.list_filter == "1" && typeof(this.listfilter[f.key]) != 'undefined' && this.listfilter[f.key] != 0
                });
                if (filterfields.length) {
                    // This will be super backward, we need to send the lookup display value
                    filterfields.forEach((f) => {
                        const filtervalue = this.listfilter[f.key];
                        const fieldweneed = this.dbfields.filter((ff) => {
                            return ff.field_name == f.key
                        });
                        const lookupoptions = fieldweneed.map((a) => {
                            return a.lookup_options;
                        })[0];
                        const value = lookupoptions.filter((a) => {
                            return a.value == filtervalue;
                        });
                        const text = value[0].text;
                        filter[f.key] = {
                            operator: '=',
                            value: text,
                        }
                    });
                    this.currentPage = 1;
                    this.filtersep = 'AND';
                    this.search = "";
                }
                this.filter = filter;
                this.orderby = orderby;
                this.orderdesc = orderdesc;
                this.data_get();
            }           
        },
        data_search: _.debounce(function() {
            this.searchcalc = true
            setTimeout(function() {
                if (this.filtering === false) {
                    this.data_searchget();
                    this.searchcalc = false;
                    this.searching = false;
                }
            }.bind(this),500)
            },300),
        data_searchget() {
            const filterfields = this.tablefields.filter((f) => {
                return f.list_filter == "1" && typeof(this.listfilter[f.key]) != 'undefined'  && this.listfilter[f.key] != 0
            });
            filterfields.map((f) => {
                this.listfilter[f.key] = 0;
            })
            var filter = "";
            if (this.search != "") {
                filter = {};
                for (var i=0;i<this.dbfields.length;i++) {
                    if (
                        (
                            this.dbfields[i].field_type == 'VARCHAR' || 
                            this.dbfields[i].field_type == 'TEXT' || 
                            this.dbfields[i].input_type == 'SELECT' || 
                            this.dbfields[i].input_type == 'SUBSELECT' || 
                            this.dbfields[i].input_type == 'NONE' 
                        ) && 
                        this.dbfields[i].list_display == 1
                    ) {
                        filter[this.dbfields[i].field_name] = {
                            operator: 'LIKE',
                            value: '*'+this.search+'*',
                        }
                    }
                }
            }            
            this.currentPage = 1;
            this.filter = filter;
            this.filtersep = 'OR';
            this.data_get();
        },
        data_sort(context) {
            this.orderby = context.sortBy;
            this.orderdesc = context.sortDesc;
            this.currentPage = 1;
            this.data_get();
        },
        data_get() {
            var filter = this.filter;
            this.loading = true;
            axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
            const data_get_url = this.tablename+'/list?';
            const url = base_url+"/"+data_get_url
                    +'&start='+(this.currentPage-1)*this.perPage
                    +'&limit='+this.perPage
                    +'&orderby='+this.orderby
                    +'&order='+(this.orderdesc?"DESC":"ASC")
                    +'&filter='+JSON.stringify(filter)
                    +'&filtersep='+this.filtersep
                    +'&mainfield='+(this.mainfield?this.mainfield:'')
                    +'&mainvalue='+(this.mainvalue?this.mainvalue:'')
            return new Promise((resolve) => {
                axios.get(
                    url,
                    {
                        headers: {
                            "Accept": "application/json",
                            "Content-type": "application/json",
                        }
                    }
                )
                .then(resp => {
                    this.records = resp.data.result.map( (a) => { 
                        a["selected"] = 0;
                        return a; 
                    });
                    this.rows = resp.data.total;
                    this.loading = false;
                    this.filtering = false;
                    this.searching = false;
                    resolve(resp);
                })
            });            
        },
        //=================
        // HELPER FUNCTIONS
        //=================
        format_date(date) {
            var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
            if (isNaN(year)) { return ''; }
            if (Number.isNaN(month)) { return ''; }
            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;
            return [year, month, day].join('-');
        },
        format_time(date) {
            if (date.length == 5) {
                return date;
            }
            var d = new Date(date);
            var h = d.getHours();
            var m = d.getMinutes();
            var hour = (h>9?'':'0')+h;
            var minute = (m>9?'':'0')+m;
            var thistime = hour+':'+minute;
            return thistime;
        },
    }
}
</script>
<style>
.gdq-w10 { width: 10px !important; }
.gdq-w20 { width: 20px !important; }
.gdq-w30 { width: 30px !important; }
.gdq-w40 { width: 40px !important; }
.gdq-w50 { width: 50px !important; }
.gdq-w60 { width: 60px !important; }
.gdq-w70 { width: 70px !important; }
.gdq-w80 { width: 80px !important; }
.gdq-w90 { width: 90px !important; }
.gdq-w100 { width: 100px !important; }
.gdq-w110 { width: 110px !important; }
.gdq-w120 { width: 120px !important; }
.gdq-w130 { width: 130px !important; }
.gdq-w140 { width: 140px !important; }
.gdq-w150 { width: 150px !important; }
.gdq-w160 { width: 160px !important; }
.gdq-w170 { width: 170px !important; }
.gdq-w180 { width: 180px !important; }
.gdq-w190 { width: 190px !important; }
.gdq-w200 { width: 200px !important; }
.gdq-w210 { width: 210px  !important; }
.gdq-inputplaceholder {
    display: inline-block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 1.75rem 0.375rem 0.75rem;
}
.gdq-chop {
  width: 200px !important; 
  min-width: 200px !important; 
  max-width: 200px !important; 
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
</style>